import React from 'react';
import { A } from '@osmosis/tailwind-ui/components/Text';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { Icon } from '@osmosis/tailwind-ui/components/Icon';
import { faAngleRight } from '@fortawesome/pro-solid-svg-icons/faAngleRight';
import {
  TrackBreadcrumbHandler,
  BreadcrumbV2Object,
} from '@osmosis/shared/types/learn';
import { getLibraryLinkWithHash } from '../../app/_lib/shared/library/logged-out/format';

type Props = {
  breadcrumb: BreadcrumbV2Object;
  linkClassName?: string;
  target?: string;
  onBreadCrumbItemClick?: TrackBreadcrumbHandler;
  title?: string;
};

/**
 * Renders V2 of breadcrumbs.
 */
const BreadcrumbsV2 = (props: Props) => {
  const { breadcrumb, linkClassName, target, title } = props;

  const trackingCrumb =
    breadcrumb?.breadcrumbs[breadcrumb.breadcrumbs.length - 1];
  const libraryLink = getLibraryLinkWithHash(breadcrumb?.link);
  return (
    <A
      className="no-underline text-gray-900 hover:text-blue-600"
      href={libraryLink}
      data-testid="breadcrumb-container"
      target={target}
      onClick={() => {
        if (props.onBreadCrumbItemClick) {
          props.onBreadCrumbItemClick(trackingCrumb || '', breadcrumb?.link);
        }
      }}
    >
      <Box className="inline break-words hyphens-auto">
        <span
          data-testid={`breadcrumb-item-${title ? title : trackingCrumb}`}
          className={`inline leading-6 flex-shrink opacity-[0.75] cursor-pointer group-hover:text-blue-600 ${linkClassName}`}
        >
          {breadcrumb?.breadcrumbs.map((crumb: string, index: number) => {
            return (
              <React.Fragment key={breadcrumb?.link + String(index)}>
                {crumb}
                {index < breadcrumb?.breadcrumbs.length - 1 && (
                  <Icon
                    icon={faAngleRight}
                    className="text-gray-300 px-1 font-bold mx-1 translate-y-[1px]"
                  />
                )}
              </React.Fragment>
            );
          })}
        </span>
      </Box>
    </A>
  );
};

export default BreadcrumbsV2;
